<template>
	<nav class="navbar navbar-expand-md navbar-light bg-light border-bottom d-block d-md-none">
		<div class="container-fluid">
			<router-link :to="{path: '/editor'}" class="navbar-brand d-flex align-items-center">
				<img src="@/assets/img/kmib-logo.png" class="me-2" style="height: 32px;" />
				<span>KMIB EDU Editor</span>
			</router-link>
			<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
				<span class="navbar-toggler-icon"></span>
			</button>
			<div class="collapse navbar-collapse" id="navbarCollapse">
				<ul class="navbar-nav me-auto mb-2 mb-md-0">
					<router-link custom :to="{path: '/editor/specialities'}" v-slot="{href, route, navigate, isActive, isExactActive}">
						<li class="nav-item">
							<a :href="href" @click="navigate" class="nav-link" :class="{'active': isExactActive}">{{$t('menu.specialities')}}</a>
						</li>
					</router-link>
					<router-link custom :to="{path: '/editor/disciplines'}" v-slot="{href, route, navigate, isActive, isExactActive}">
						<li class="nav-item">
							<a :href="href" @click="navigate" class="nav-link" :class="{'active': isExactActive}">{{$t('menu.disciplines')}}</a>
						</li>
					</router-link>
					<router-link custom :to="{path: '/editor/students-groups'}" v-slot="{href, route, navigate, isActive, isExactActive}">
						<li class="nav-item">
							<a :href="href" @click="navigate" class="nav-link" :class="{'active': isExactActive}">{{$t('menu.students.groups')}}</a>
						</li>
					</router-link>
					<hr class="my-1" />
					<li class="nav-item">
						<router-link :to="{path: '/logout'}" class="nav-link">{{$t('btn.logout')}}</router-link>
					</li>
					<li class="nav-item dropdown">
						<a class="nav-link dropdown-toggle" href="javascript://" role="button" data-bs-toggle="dropdown" aria-expanded="false">
							{{appModel.getLang().toUpperCase()}}
						</a>
						<ul class="dropdown-menu">
							<li v-for="(langname, langkey) in appModel.langsName" :key="'lang-'+langkey">
								<a class="dropdown-item" :class="{'active': langkey == appModel.getLang()}" href="javascript://" @click="appModel.setLang(langkey)">{{langname}}</a>
							</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	</nav>
	<div class="container-fluid">
		<div class="row">
			<div class="sidebar min-vh-100 border-end col-md-3 col-lg-2 p-3 bg-body-tertiary d-none d-md-block">
				<router-link :to="{path: '/editor'}" class="d-flex align-items-center mb-3 mb-md-0 me-md-auto link-body-emphasis text-decoration-none">
					<img src="@/assets/img/kmib-logo.png" class="me-2" style="width: 40px;" />
					<strong>KMIB EDU Editor</strong>
				</router-link>
				<hr>
				<ul class="nav nav-pills flex-column mb-auto gap-2">
					<router-link custom :to="{path: '/editor/specialities'}" v-slot="{href, route, navigate, isActive, isExactActive}">
						<li class="nav-item">
							<a :href="href" @click="navigate" class="nav-link" :class="{'active': isExactActive, 'link-body-emphasis': !isExactActive}">{{$t('menu.specialities')}}</a>
						</li>
					</router-link>
					<router-link custom :to="{path: '/editor/disciplines'}" v-slot="{href, route, navigate, isActive, isExactActive}">
						<li class="nav-item">
							<a :href="href" @click="navigate" class="nav-link" :class="{'active': isExactActive, 'link-body-emphasis': !isExactActive}">{{$t('menu.disciplines')}}</a>
						</li>
					</router-link>
					<router-link custom :to="{path: '/editor/students-groups'}" v-slot="{href, route, navigate, isActive, isExactActive}">
						<li class="nav-item">
							<a :href="href" @click="navigate" class="nav-link" :class="{'active': isExactActive, 'link-body-emphasis': !isExactActive}">{{$t('menu.students.groups')}}</a>
						</li>
					</router-link>
				</ul>
			</div>
			<main class="col-md-9 col-lg-10 ms-sm-auto px-md-4">
				<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
					<h1 class="h2">{{$t(appModel.pageTitle) || 'BilimCert'}}</h1>
					<div class="btn-toolbar mb-2 mb-md-0 gap-2 d-none d-md-flex">
						<div class="btn-group" role="group">
							<button type="button" class="btn btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
								{{appModel.getLang().toUpperCase()}}
							</button>
							<ul class="dropdown-menu">
								<li v-for="(langname, langkey) in appModel.langsName" :key="'lang-'+langkey">
									<a class="dropdown-item" :class="{'active': langkey == appModel.getLang()}" href="javascript://" @click="appModel.setLang(langkey)">{{langname}}</a>
								</li>
							</ul>
						</div>
						<router-link :to="{path: '/logout'}" class="btn btn-outline-secondary">{{$t('btn.logout')}}</router-link>
					</div>
				</div>
				<router-view/>
			</main>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'KMIB EDU Editor'});
	},
	data: () => ({
		
	}),
	computed: {},
	methods: {},
	mounted(){},
	components: {},
}
</script>